export const emDESENVOLVIMENTO = false

export const VERSAO_SISTEMA: string = '2.33'